<template>
    <div class="store-push " :class="{'show-push': show }" v-if="popup && popup.popup_hp_toggle == 1">
        <svg class="icon icon-cross close" @click="removeStorePush">
                <use xlink:href="#icon-cross"></use>
            </svg>
        <h3>
            {{ popup.popup_hp_text}}
        </h3>
        <renault-button
            :text="popup.popup_hp_cta_text"
            is-black
            isAnchor
            :href="popup.popup_hp_cta_url"
            :target="popup.popup_hp_cta_blank  == 1 ? '_blank' : '_self'"
        />
    </div>
</template>

<script>
import RenaultButton from './RenaultButton.vue';
export default {
    components: {
        RenaultButton,
    },
    data() {
        return {
            show: false
        }
    },

    computed: {
        popup() {
            return window.data?.popup
        },
    },

    methods: {
        removeStorePush() {
            this.show = false
        }
    },
    mounted () {
        setTimeout(() => {
            this.show = true
        }, 400);
    },
}
</script>
